// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"b8052e78","283":"e9575698","424":"97e771a5","583":"242d4fa7","644":"c2e4a45b","684":"89e00635","779":"c96b5693","787":"2741b8eb","914":"77d850dd"}[chunkId] + ".chunk.js";
};